import { Box, Typography, useTheme } from "@mui/material";

/** Panel sections — accent title bar, soft border, rounded-2xl. */
export default function DashboardPanelCard({ title, subtitle, children, className = "mt-3 mx-0 max-sm:mx-auto" }) {
    const theme = useTheme();

    return (
        <Box
            sx={{
                backgroundColor: theme.palette.background.paper,
                border: "1px solid",
                borderColor: theme.palette.mode === "dark" ? "divider" : "#e2e8f0",
                overflow: "hidden",
            }}
            className={`rounded-2xl shadow-md ${className}`}
        >
            {title ? (
                <Box
                    sx={{
                        px: 2.5,
                        py: 1.75,
                        borderBottom: "1px solid",
                        borderColor: theme.palette.mode === "dark" ? "divider" : "#eef2f7",
                        background: theme.palette.mode === "dark"
                            ? theme.palette.background.paper
                            : "linear-gradient(to left, #f8fafc, #ffffff)",
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: 800, color: "#0D358C" }}>
                        {title}
                    </Typography>
                    {subtitle ? (
                        <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.25 }}>
                            {subtitle}
                        </Typography>
                    ) : null}
                </Box>
            ) : null}
            <Box className="px-3 py-3">{children}</Box>
        </Box>
    );
}
